import React from "react";
import { useQuery } from "@tanstack/react-query";
import parse from "html-react-parser";

import { useThemeChange } from "../../../utils/themeChange";
import { useApi } from "../../../hooks/api/useApi";
import { CMS } from "../../../constants/api-constants";

const { TEMPLATES } = CMS;

const Index = () => {
  const themeChange = useThemeChange();
  const { getById } = useApi();

  const whyArtswapContent = useQuery({
    queryKey: ["why_artswap"],
    queryFn: () => getById("WHY_ARTSWAP", TEMPLATES),
  });

  if (whyArtswapContent.isSuccess && whyArtswapContent?.data) {
    const whyArtswap_content = JSON.parse(whyArtswapContent?.data?.data);
    var content = parse(whyArtswap_content?.why_artswap);
  }
  return (
    <div className={themeChange.add("section")}>
      <section className="container static-page-container">
        <span className="spacer-30" />
        {content ? (
          content
        ) : (
          <div className="error">
            <p>Data Unavailable. Please contact admin.</p>
          </div>
        )}
        {/* <span className="spacer-30" />
        <h2>Why Artswap</h2>
        <span className="spacer-30" />
        <p>
          Early digital fine artists have taken the plunge and began selling
          their art to collectors in increasing numbers. A natural extension of
          that success is to commercialize this unique art for consumer
          consumption.
        </p>
        <p>
          While the Financial Times recognized that with "wealthy young
          collectors new to the art world — and its rarefied institutions and
          opaque codes of taste and refinement — the intangible may represent
          the future”, consumers may ultimately be the ones who provide the
          required fuel to power this industry.
        </p>
        <p>
          The team at ArtSwap cordially invites all fine artists to test out its
          licensing platform today.
        </p> */}
      </section>
    </div>
  );
};

export default Index;
